import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-bezier-curve-icon',
  templateUrl: './design-bezier-curve.component.html'
})
export class DesignBezierCurveComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
